export default {
    methods: {
        translateCategory(category) {
            const licenseCategories = {
                A: 'MC',
                A1: 'Lille MC',
                A2: 'Mellem MC',
                B: 'Bil',
            };
            return licenseCategories[category];
        },
    }
}